export const messages: Array<{
  name: string;
  status: string;
  text: string;
  timestamp: any;
  color: string;
}> = [
  {
    name: 'another agent',
    status: 'available',
    text: "You're welcome. I'm glad we were able to get that figured out together",
    timestamp: new Date(
      new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).setHours(15, 30, 0, 0)
    ).toISOString(),
    color: '#FBC231',
  },
  {
    name: 'self',
    status: 'available',
    text: "This is a conversation about lunch so it isn't recorded at all and I'm very happy about that, because we were talking about Thai food. But I'm not really down with Thai food. So I was suggesting that we should grab burgers instead",
    timestamp: new Date(
      new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(10, 30, 0, 0)
    ).toISOString(),
    color: '#EE67AF',
  },
  {
    name: 'another agent',
    status: 'available',
    text: "I don't know. I had burgers yesterday. Pizza??",
    timestamp: new Date(
      new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(10, 40, 0, 0)
    ).toISOString(),
    color: '#FBC231',
  },
  {
    name: 'self',
    status: 'available',
    text: 'This is now a message that ia about my interaction with Peter. Does this needs to be tracked somehow?',
    timestamp: new Date(Date.now() - 15 * 60 * 1000).toISOString(),
    color: '#EE67AF',
  },
  {
    name: 'another agent',
    status: 'available',
    text: "Yeah, I can help you out with Peter. I'm available now, so what can I help you with?",
    timestamp: new Date(Date.now() - 5 * 60 * 1000).toISOString(),
    color: '#FBC231',
  },
];

export const supervisorMessages: Array<{
  name: string;
  status: string;
  text: string;
  timestamp: any;
  color: string;
}> = [
  {
    name: 'another agent',
    status: 'available',
    text: 'Hi, just a heads up — your average handle time this week is slightly above the team target. Is everything okay on your end?',
    timestamp: new Date(
      new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(9, 10, 0, 0)
    ).toISOString(),
    color: '#FBC231',
  },
  {
    name: 'self',
    status: 'available',
    text: "Yes, I've had a few complex refund cases back to back. I've been spending extra time documenting them properly.",
    timestamp: new Date(
      new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(9, 13, 0, 0)
    ).toISOString(),
    color: '#EE67AF',
  },
  {
    name: 'another agent',
    status: 'available',
    text: 'Good to hear — thorough documentation is important. If you need help triaging complex cases faster, I can set up a 15-min session with you.',
    timestamp: new Date(
      new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(9, 15, 0, 0)
    ).toISOString(),
    color: '#FBC231',
  },
  {
    name: 'self',
    status: 'available',
    text: "That would be really helpful, thank you! Tomorrow afternoon works well for me.",
    timestamp: new Date(Date.now() - 20 * 60 * 1000).toISOString(),
    color: '#EE67AF',
  },
  {
    name: 'another agent',
    status: 'available',
    text: "Perfect. I'll send a calendar invite for 2 PM. Keep up the good work!",
    timestamp: new Date(Date.now() - 5 * 60 * 1000).toISOString(),
    color: '#FBC231',
  },
];

export const groupMessages: Array<{
  name: string;
  status: string;
  text: string;
  timestamp: any;
  color: string;
}> = [
  {
    name: 'Jeff Davis',
    status: 'available',
    text: 'Lorem ipsum dolor sit amet consectetur. Pretium amet lacus mi nibh. Quisque felis dignissim risus amet aliquet adipiscing. Cras vitae dui augue enim fringilla nec.',
    timestamp: new Date(
      new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(10, 50, 0, 0)
    ).toISOString(),
    color: '#13DFCA',
  },
  {
    name: 'Jeff Davis',
    status: 'available',
    text: 'Lorem ipsum dolor sit amet consectetur. Pretium amet lacus mi nibh. Quisque felis dignissim risus amet aliquet adipiscing. Cras vitae dui augue enim fringilla nec.',
    timestamp: new Date(
      new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(10, 45, 0, 0)
    ).toISOString(),
    color: '#13DFCA',
  },
  {
    name: 'Shirley King',
    status: 'offline',
    text: 'Lorem ipsum dolor sit amet consectetur. Pretium amet lacus mi nibh. Quisque felis dignissim risus amet aliquet adipiscing. Cras vitae dui augue enim fringilla nec.',
    timestamp: new Date(
      new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(10, 40, 0, 0)
    ).toISOString(),
    color: '#FBC231',
  },
  {
    name: 'Norman Nelson',
    status: 'working',
    text: 'Lorem ipsum dolor sit amet consectetur. Pretium amet lacus mi nibh. Quisque felis dignissim risus amet aliquet adipiscing. Cras vitae dui augue enim fringilla nec.',
    timestamp: new Date(
      new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(10, 35, 0, 0)
    ).toISOString(),
    color: '#00B2FF',
  },
  {
    name: 'Shirley King',
    status: 'available',
    text: 'Lorem ipsum dolor sit amet consectetur. Pretium amet lacus mi nibh. Quisque felis dignissim risus amet aliquet adipiscing. Cras vitae dui augue enim fringilla nec.',
    timestamp: new Date(
      new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(10, 30, 0, 0)
    ).toISOString(),
    color: '#FBC231',
  },
  {
    name: 'Donna Wilson',
    status: 'busy',
    text: 'Lorem ipsum dolor sit amet consectetur. Pretium amet lacus mi nibh. Quisque felis dignissim risus amet aliquet adipiscing. Cras vitae dui augue enim fringilla nec.',
    timestamp: new Date(Date.now() - 15 * 60 * 1000).toISOString(),
    color: '#FF9000',
  },
  {
    name: 'Harvey Martin',
    status: 'offline',
    text: 'Lorem ipsum dolor sit amet consectetur. Pretium amet lacus mi nibh. Quisque felis dignissim risus amet aliquet adipiscing. Cras vitae dui augue enim fringilla nec.',
    timestamp: new Date(Date.now() - 5 * 60 * 1000).toISOString(),
    color: '#B266FF',
  },
];

export const groupMembers: Array<{
  name: string;
  status: string;
}> = [
  {
    name: 'Jeff Davis',
    status: 'available',
  },
  {
    name: 'Shirley King',
    status: 'offline',
  },
  {
    name: 'Norman Nelson',
    status: 'working',
  },
  {
    name: 'Donna Wilson',
    status: 'busy',
  },
  {
    name: 'Harvey Martin',
    status: 'offline',
  },
];

export const agentsData: Array<{
  name: string;
  status: string;
  messages: typeof messages;
  isFavorite?: boolean;
  isMessageRead?: boolean;
}> = [
  {
    name: 'Jorge Rodriguez',
    status: 'available',
    messages: messages,
    isFavorite: true,
    isMessageRead: true,
  },
  {
    name: 'Lana Moore',
    status: 'busy',
    messages: messages,
    isFavorite: true,
    isMessageRead: true,
  },
  {
    name: 'Teri MacGyver',
    status: 'working',
    messages: messages,
    isFavorite: true,
    isMessageRead: true,
  },
  {
    name: 'Russell Thompson',
    status: 'available',
    messages: messages,
    isFavorite: true,
    isMessageRead: true,
  },
  {
    name: 'Barry Perez',
    status: 'available',
    messages: messages,
    isFavorite: true,
    isMessageRead: true,
  },
  {
    name: 'Marie Thompson',
    status: 'offline',
    messages: messages,
    isFavorite: true,
    isMessageRead: true,
  },
  {
    name: 'Pam wilson',
    status: 'working',
    messages: messages,
    isFavorite: true,
    isMessageRead: true,
  },
  {
    name: 'Samuel Perry',
    status: 'busy',
    messages: messages,
    isFavorite: true,
    isMessageRead: true,
  },
  {
    name: 'Supervisor',
    status: 'available',
    messages: supervisorMessages,
    isFavorite: false,
    isMessageRead: false,
  },
  {
    name: 'John Miller',
    status: 'available',
    messages: messages,
    isFavorite: false,
    isMessageRead: false,
  },
  {
    name: 'Sophie Cronin',
    status: 'available',
    messages: messages,
    isFavorite: false,
    isMessageRead: true,
  },
  {
    name: 'Jana Parker',
    status: 'working',
    messages: messages,
    isFavorite: false,
    isMessageRead: true,
  },
  {
    name: 'Zach Yundt',
    status: 'available',
    messages: messages,
    isFavorite: false,
    isMessageRead: true,
  },
  {
    name: 'Ellen cartwright',
    status: 'offline',
    messages: messages,
    isFavorite: false,
    isMessageRead: true,
  },
  {
    name: 'Bryan Zemalk',
    status: 'busy',
    messages: messages,
    isFavorite: false,
    isMessageRead: true,
  },
];

export const agentGroupsData: Array<{
  name: string;
  messages: typeof groupMessages;
  groupMembers: typeof groupMembers;
  isMessageRead?: boolean;
}> = [
  {
    name: 'Customer Service',
    messages: groupMessages,
    groupMembers: groupMembers,
    isMessageRead: false,
  },
  {
    name: 'Sandy Design Team',
    messages: groupMessages,
    groupMembers: groupMembers,
    isMessageRead: true,
  },
  {
    name: 'Sales',
    messages: groupMessages,
    groupMembers: groupMembers,
    isMessageRead: true,
  },
  {
    name: 'UX/PMs',
    messages: groupMessages,
    groupMembers: groupMembers,
    isMessageRead: true,
  },
  {
    name: 'Research',
    messages: groupMessages,
    groupMembers: groupMembers,
    isMessageRead: true,
  },
];

const statuses = ['available', 'offline', 'busy', 'working'];

/**
 * Function to go get random status for the agent
 * @example getRandomAgentStatus()
 */
const getRandomAgentStatus = () =>
  statuses[Math.floor(Math.random() * statuses.length)];

export const activeAgentsList: Array<{
  name: string;
  status: string;
}> = [
  { name: 'Allon Rodin', status: getRandomAgentStatus() },
  { name: 'Tracey Dodd', status: getRandomAgentStatus() },
  { name: 'Dave Hinkle', status: getRandomAgentStatus() },
  { name: 'Dale Gordon', status: getRandomAgentStatus() },
  { name: 'Trevenn Barthelot', status: getRandomAgentStatus() },
  { name: 'Rasheeda Moore', status: getRandomAgentStatus() },
  { name: 'Sandeep Mallya', status: getRandomAgentStatus() },
  { name: 'Todd Durfee', status: getRandomAgentStatus() },
  { name: 'James Dunleavy', status: getRandomAgentStatus() },
  { name: 'Josh Gibson', status: getRandomAgentStatus() },
  { name: 'Kevin Jensen', status: getRandomAgentStatus() },
  { name: 'Peter Stoesz', status: getRandomAgentStatus() },
  { name: 'Ed Kawecki', status: getRandomAgentStatus() },
  { name: 'Olivier Attia', status: getRandomAgentStatus() },
  { name: 'Charl Van Den Berg', status: getRandomAgentStatus() },
  { name: 'Adam Robinson', status: getRandomAgentStatus() },
  { name: 'Jed Woffinden', status: getRandomAgentStatus() },
  { name: 'Josh Groesz', status: getRandomAgentStatus() },
  { name: 'Andre Fernandes', status: getRandomAgentStatus() },
  { name: 'Yuval Schwartz', status: getRandomAgentStatus() },
  { name: 'Maria Laurido', status: getRandomAgentStatus() },
  { name: 'Thomas Sewell', status: getRandomAgentStatus() },
  { name: 'Michael Fritz', status: getRandomAgentStatus() },
  { name: 'Paulo Paulino', status: getRandomAgentStatus() },
  { name: 'Nadeem Akram', status: getRandomAgentStatus() },
  { name: 'Jacob Rivers', status: getRandomAgentStatus() },
  { name: 'Charles Cruise', status: getRandomAgentStatus() },
  { name: 'Trevor Berard', status: getRandomAgentStatus() },
  { name: 'Damian Heavey', status: getRandomAgentStatus() },
  { name: 'Danny Eschete', status: getRandomAgentStatus() },
  { name: 'David Allen', status: getRandomAgentStatus() },
  { name: 'Jesse Huff', status: getRandomAgentStatus() },
  { name: 'Kyle Taylor', status: getRandomAgentStatus() },
  { name: 'Kyle Hurley', status: getRandomAgentStatus() },
  { name: 'Lucas Ramires Vieira', status: getRandomAgentStatus() },
  { name: 'Michael Brown', status: getRandomAgentStatus() },
  { name: 'Mike Goode', status: getRandomAgentStatus() },
  { name: 'Phil Hildreth', status: getRandomAgentStatus() },
  { name: 'Ryan Read', status: getRandomAgentStatus() },
  { name: 'Rick Trento', status: getRandomAgentStatus() },
  { name: 'Francisco Felix Soto', status: getRandomAgentStatus() },
  { name: 'Ben Elliot', status: getRandomAgentStatus() },
  { name: 'Cara Celements', status: getRandomAgentStatus() },
  { name: 'Taylor Moreland', status: getRandomAgentStatus() },
  { name: 'Mike Abel', status: getRandomAgentStatus() },
  { name: 'Ernst Kruger', status: getRandomAgentStatus() },
  { name: 'Saen Lima', status: getRandomAgentStatus() },
  { name: 'Emily Ivers', status: getRandomAgentStatus() },
  { name: 'John Jennings', status: getRandomAgentStatus() },
  { name: 'Kim Steele', status: getRandomAgentStatus() },
  { name: 'Trevor Anderson', status: getRandomAgentStatus() },
  { name: 'Rory Fellers', status: getRandomAgentStatus() },
  { name: 'Ashlie Mattson', status: getRandomAgentStatus() },
  { name: 'Brian Henson', status: getRandomAgentStatus() },
  { name: 'Ronald Bailey', status: getRandomAgentStatus() },
  { name: 'Teneka Armstead', status: getRandomAgentStatus() },
  { name: 'Teresa Beeman', status: getRandomAgentStatus() },
  { name: 'Martha Berry', status: getRandomAgentStatus() },
  { name: 'Jason Allen', status: getRandomAgentStatus() },
  { name: 'Rob Wilson', status: getRandomAgentStatus() },
  { name: 'Andrew Loewith', status: getRandomAgentStatus() },
  { name: 'Eric Nemeth', status: getRandomAgentStatus() },
  { name: 'Jacob Bentley', status: getRandomAgentStatus() },
  { name: 'Stacey Kaiser', status: getRandomAgentStatus() },
  { name: "Kristie O'Donnell", status: getRandomAgentStatus() },
  { name: 'Tom McCarten', status: getRandomAgentStatus() },
  { name: 'Andy Marchky', status: getRandomAgentStatus() },
];
